<template>
  <notificationGroup group="bottom" position="bottom">
    <div class="inset-0 flex px-4 py-6 pointer-events-none p-6 items-start justify-end" style="pointer-events:none;">
      <div class="w-100" style="pointer-events:auto;">
        <notification v-slot="{ notifications, close }">
        <!-- <div class="d-flex max-w-sm w-100 mx-auto bg-white shadow-md rounded-lg overflow-hidden mt-4"> -->
          <div
            class="notification-container rounded-lg max-w-sm w-full mx-auto shadow-md overflow-hidden"
            v-for="notification in notifications"
            :key="notification.id" @click="close(notification.id)">
            <button class="btn-close">
              <svg width="14" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9663 11.1996L8.43334 6.66667L12.9663 2.13371C13.4557 1.64432 13.4557 0.856436 12.9663 0.367044C12.4769 -0.122348 11.689 -0.122348 11.1996 0.367044L6.66667 4.9L2.13371 0.367044C1.64432 -0.122348 0.856436 -0.122348 0.367044 0.367044C-0.122348 0.856436 -0.122348 1.64432 0.367044 2.13371L4.9 6.66667L0.367044 11.1996C-0.122348 11.689 -0.122348 12.4769 0.367044 12.9663C0.856436 13.4557 1.64432 13.4557 2.13371 12.9663L6.66667 8.43334L11.1996 12.9663C11.689 13.4557 12.4769 13.4557 12.9663 12.9663C13.4522 12.4769 13.4522 11.6855 12.9663 11.1996Z" fill="white"/>
              </svg>
            </button>

            <div class="d-flex mx-5 justify-content-center">
              <span class="text-sm">{{ notification.text }}</span>
            </div>
          </div>
        </notification>
      </div>
    </div>
  </notificationGroup>
</template>

<script>

export default {
  name: 'Notifications',
  props: {
    eventName: {
      type: String,
      default: 'mr-notif'
    },
    noReset: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      notification: {
        id: 'notif-0',
        title: 'Success',
        text: 'Description'
      }
    }
  },
  created () {
    if (!this.noReset) {
      this.$bus.$off(this.eventName)
    }
    this.$bus.$on(this.eventName, data => {
      this.$notify({
        group: 'bottom',
        text: data.text
      }, 8000)
    })
  }
}
</script>

<style>
</style>
